
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  model: {
    prop: "url",
    event: "change"
  }
})
export default class Template extends Vue {
  @Prop({ default: "" })
  url: string;
  visible: boolean = false;
  defaultUrl: string = "https://static.gtech.asia/static/speedbiz/check/air_conditioning.png";
  iconRemoteUrls: any = [
    "https://static.gtech.asia/static/speedbiz/check/air_conditioning.png",
    "https://static.gtech.asia/static/speedbiz/check/air_filter.png",
    "https://static.gtech.asia/static/speedbiz/check/battery.png",
    "https://static.gtech.asia/static/speedbiz/check/belts.png",
    "https://static.gtech.asia/static/speedbiz/check/brake_discs.png",
    "https://static.gtech.asia/static/speedbiz/check/brake_fluid.png",
    "https://static.gtech.asia/static/speedbiz/check/brake_pads.png",
    "https://static.gtech.asia/static/speedbiz/check/car_exterior.png",
    "https://static.gtech.asia/static/speedbiz/check/coolant.png",
    "https://static.gtech.asia/static/speedbiz/check/lighting.png",
    "https://static.gtech.asia/static/speedbiz/check/motor_oil.png",
    "https://static.gtech.asia/static/speedbiz/check/oil_filter.png",
    "https://static.gtech.asia/static/speedbiz/check/seats.png",
    "https://static.gtech.asia/static/speedbiz/check/steering_oil.png",
    "https://static.gtech.asia/static/speedbiz/check/vehicle_inspection.png",
    "https://static.gtech.asia/static/speedbiz/check/wheels.png",
    "https://static.gtech.asia/static/speedbiz/check/wiper.png"
  ];
  get $url() {
    return this.url;
  }
  created() {
    if (!this.$url) {
      this.$emit("change", this.defaultUrl);
    }
  }
  handleSelectIcon(url) {
    this.visible = false;
    this.$emit("change", url);
  }
}
